<div class="recurrence-container">
  <div class="recurrence-toggle">
    <mat-slide-toggle
      [checked]="enabled"
      (change)="onToggle($event.checked)"
      color="primary">
    </mat-slide-toggle>
    <mat-icon>repeat</mat-icon>
    <span>Repeat</span>
  </div>

  @if (enabled) {
    <div class="recurrence-fields">
      <!-- Frequency Row -->
      <div class="frequency-row">
        @if (frequencyControl.value !== 'WEEKDAYS') {
          <span>Every</span>
          <mat-form-field appearance="outline" class="interval-field">
            <input matInput type="number" [formControl]="intervalControl" min="1" max="365" (keydown)="preventNegative($event)" (blur)="enforceMin(intervalControl, 1)">
          </mat-form-field>
        }
        <mat-form-field appearance="outline" class="frequency-field">
          <mat-select [formControl]="frequencyControl" (selectionChange)="onFrequencyChange($event.value)">
            <mat-option value="DAILY">{{ intervalControl.value > 1 ? 'Days' : 'Day' }}</mat-option>
            <mat-option value="WEEKDAYS">Weekdays (Mon-Fri)</mat-option>
            <mat-option value="WEEKLY">{{ intervalControl.value > 1 ? 'Weeks' : 'Week' }}</mat-option>
            <mat-option value="MONTHLY">{{ intervalControl.value > 1 ? 'Months' : 'Month' }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Days of Week (for WEEKLY) -->
      @if (frequencyControl.value === 'WEEKLY') {
        <div class="days-of-week">
          @for (day of weekDays; track day.value) {
            <button type="button"
              class="day-chip"
              [class.selected]="isDaySelected(day.value)"
              (click)="toggleDay(day.value)">
              {{ day.label }}
            </button>
          }
        </div>
      }

      <!-- Day of Month (for MONTHLY) -->
      @if (frequencyControl.value === 'MONTHLY') {
        <div class="frequency-row">
          <span>On day</span>
          <mat-form-field appearance="outline" class="interval-field">
            <input matInput type="number" [formControl]="dayOfMonthControl" min="1" max="31" (keydown)="preventNegative($event)" (blur)="enforceMin(dayOfMonthControl, 1)">
          </mat-form-field>
        </div>
      }

      <!-- End Condition -->
      <div class="end-section">
        <mat-radio-group [formControl]="endTypeControl" class="end-section">
          <div class="end-option">
            <mat-radio-button value="NEVER">Never ends</mat-radio-button>
          </div>
          <div class="end-option">
            <mat-radio-button value="AFTER_COUNT">After</mat-radio-button>
            @if (endTypeControl.value === 'AFTER_COUNT') {
              <mat-form-field appearance="outline" class="end-count-field">
                <input matInput type="number" [formControl]="endCountControl" min="1" max="999" (keydown)="preventNegative($event)" (blur)="enforceMin(endCountControl, 1)">
              </mat-form-field>
              <span>occurrences</span>
            }
          </div>
          <div class="end-option">
            <mat-radio-button value="UNTIL_DATE">Until</mat-radio-button>
            @if (endTypeControl.value === 'UNTIL_DATE') {
              <mat-form-field appearance="outline" class="end-date-field">
                <input matInput [matDatepicker]="endPicker" [formControl]="endDateControl" readonly (click)="endPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            }
          </div>
        </mat-radio-group>
      </div>
    </div>
  }
</div>
